import { SIZES as e } from "./watson.es38.js";
const n = [...e], r = "none", S = [
  "row",
  "column",
  "row-reverse",
  "column-reverse"
], o = [
  "flex-start",
  "flex-end",
  "center",
  "baseline",
  "stretch"
], s = [
  "flex-start",
  "flex-end",
  "center",
  "space-between"
];
export {
  o as STACK_ALIGNMENTS,
  S as STACK_DIRECTIONS,
  s as STACK_JUSTIFY_CONTENTS,
  n as STACK_SIZES,
  r as STACK_SIZE_DEFAULT
};
